import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
var BaseService = /** @class */ (function () {
    function BaseService(logger, api) {
        this.logger = logger;
        this.api = api;
    }
    BaseService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    BaseService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return BaseService;
}());
export { BaseService };
//# sourceMappingURL=base.service.js.map